const PRODUCT_TABLE_HEADER_COLUMNS = [
  {
    id: 'title',
    headerName: 'Title',
    sortable: false,
  },
  {
    id: 'language',
    headerName: 'Languages',
    sortable: false,
  },
  {
    id: 'modifiedTimestamp',
    headerName: 'Last edited',
    sortable: true,
  },
  {
    id: 'actions',
    headerName: 'Actions',
    sortable: false,
  },
];

export default PRODUCT_TABLE_HEADER_COLUMNS;
